export const jsDate = (momentObj) => new Date(momentObj.format('YYYY-MM-DDTHH:mm:ss'));

export const getMetalsFromGroups = (groups) => {
    const reg = /^[a-z]+(-)([a-z]{2})(-[a-z]+){0,2}$/g;
    return groups.map((g) => (g.match(reg) ? g.replace(reg, '$2') : 'cu'));
};